// Company parcel tracking (Stock Management › Parcel Tracking and Profile › My Parcels).
const cargo = {
  titleCompany: 'Parcel Tracking',
  subtitleCompany: 'Every parcel coming into and going out of the company. Tap a row to open its details and update its status with a single tap.',
  helpPersonal: 'Use "Send a Parcel" for a parcel leaving the company and "Receive a Parcel" for one coming to you. As you update the status, the stock items linked to the parcel are booked automatically.',
  actions: {
    access: 'Permissions',
    receive: 'Receive a Parcel',
    send: 'Send a Parcel',
  },
  stats: {
    label: 'Parcel summary and quick filter',
    all: 'Total',
    incoming: 'Incoming',
    outgoing: 'Outgoing',
    inTransit: 'In transit',
    overdue: 'Overdue',
    cost: 'Shipping Cost',
    costShort: 'Cost',
  },
  search: 'Search subject, person, organisation or tracking number...',
  loading: 'Loading parcels',
  loadError: 'Parcel records couldn’t be loaded. Please refresh the page.',
  count_one: '{{count}} parcel',
  count_other: '{{count}} parcels',
  empty: {
    noneTitle: 'No parcel records yet',
    noneText: 'Create the first one with "Send a Parcel" or "Receive a Parcel".',
    noMatchTitle: 'No matching parcels',
    noMatchText: 'Try a different search or filter.',
    clearFilters: 'Clear the filter',
  },
  direction: {
    incoming: {
      label: 'Incoming Parcel',
      short: 'Incoming',
      description: 'Sent to our company, to be received',
      party: 'Sender',
      partyName: 'Sender Name',
      address: 'Origin Address',
    },
    outgoing: {
      label: 'Outgoing Parcel',
      short: 'Outgoing',
      description: 'Sent from our company',
      party: 'Recipient',
      partyName: 'Recipient Name',
      address: 'Delivery Address',
    },
  },
  status: {
    incoming: {
      not_sent: 'Expected',
      shipped: 'In transit',
      delivered: 'Received',
      returned: 'Returned / Problem',
    },
    outgoing: {
      not_sent: 'Being prepared',
      shipped: 'Shipped',
      delivered: 'Delivered',
      returned: 'Returned / Problem',
    },
  },
  overdue: 'Overdue',
  carriers: {
    kurye: 'Courier / hand delivery',
    diger: 'Other',
  },
  list: {
    owner: 'Logged by {{name}}',
    items_one: '{{count}} stock item linked',
    items_other: '{{count}} stock items linked',
    files_one: '{{count}} file',
    files_other: '{{count}} files',
    noCarrier: 'No carrier chosen',
    dates: {
      delivered: 'Delivered',
      expected: 'Expected',
      shipped: 'Shipped',
    },
  },
  toast: {
    added: 'Parcel record added',
    updated: 'Parcel record updated',
    saveError: 'The parcel record couldn’t be saved',
    statusChanged: 'Status changed to "{{status}}"',
    statusError: 'The status couldn’t be updated',
    deleted: 'Parcel record deleted',
    deleteError: 'The parcel record couldn’t be deleted',
    copied: 'Tracking number copied',
    copyError: 'Couldn’t copy',
    waitUpload: 'Please wait until the upload finishes',
    unsupported: '{{name}}: file type not supported',
    tooLarge: '{{name}}: file is larger than 10 MB',
    uploadError: 'Something went wrong while uploading the file',
    staffError: 'The employee list couldn’t be loaded',
    accessGranted: '{{name}}: parcel access granted',
    accessRevoked: '{{name}}: parcel access removed',
    accessError: 'The permission couldn’t be updated',
  },
  confirmDelete: {
    title: 'Delete this parcel record?',
    message: 'The parcel record "{{subject}}" will be deleted permanently.',
    stockNote: 'Quantities booked to stock will be reversed.',
    confirm: 'Yes, delete',
    cancel: 'Cancel',
  },
  form: {
    titleNew: 'New Parcel Record',
    titleEdit: 'Edit Parcel Record',
    subtitle: 'Starred fields are required; fill in the rest as the parcel moves along.',
    directionLabel: 'Parcel direction',
    sections: {
      shipment: 'Shipment',
      shipmentHint: 'Write a short title that makes the parcel easy to find in the list.',
      status: 'Status and Carrier',
      party: 'Other party',
      partyHint: 'Who sends the parcel / who receives it. The phone number lets you reach them quickly if something goes wrong.',
      items: 'Stock Items',
      files: 'Files and Note',
      filesHint: 'Attach a photo of the receipt, waybill or delivery note; it is kept with the record.',
    },
    subject: 'Subject',
    subjectPlaceholder: 'e.g. Lab kit delivery from the supplier',
    content: 'Contents',
    contentPlaceholder: 'What’s in the box? Materials, quantities, lot numbers...',
    statusHint: 'Choosing a status fills in the ship and delivery dates automatically; you can still change them.',
    carrier: 'Carrier',
    carrierPlaceholder: 'Choose...',
    tracking: 'Tracking No',
    trackingPlaceholder: 'Tracking number',
    cost: 'Shipping Cost',
    costPlaceholder: '0.00',
    shippedAt: 'Ship Date',
    expectedAt: 'Expected Delivery',
    expectedHint: 'Once this date passes, the parcel is marked "Overdue".',
    deliveredAt: 'Delivery Date',
    partyPlaceholder: 'Full name or company',
    partyOrg: 'Organisation / Site',
    partyOrgPlaceholder: 'Hospital, supplier...',
    partyPhone: 'Phone',
    partyPhonePlaceholder: '05xx xxx xx xx',
    addressPlaceholder: 'Address',
    note: 'Note',
    notePlaceholder: 'Anything you’d like to add',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    saving: 'Saving...',
    errors: {
      subject: 'A subject is required',
      party: '{{party}} is required',
      carrier: 'Choose a carrier once the parcel is on its way',
      cost: 'Enter a valid amount (e.g. 125.50)',
      items: 'Enter a quantity for every stock you chose',
    },
  },
  items: {
    hint: {
      incoming: 'These items are added to stock when the parcel is marked "Received".',
      outgoing: 'These items are deducted from stock when the parcel is marked "Shipped".',
    },
    empty: 'No stock items added. Add them if the parcel carries material from stock; otherwise leave this section empty.',
    stock: 'Stock',
    stockPlaceholder: 'Choose a stock...',
    option: '{{name}} (left: {{remaining}})',
    quantity: 'Qty',
    remove: 'Remove item',
    add: 'Add a stock item',
  },
  files: {
    drop: 'Drag the receipt, waybill or delivery note here, or click',
    uploading: 'Uploading...',
    dropHint: 'PDF, image, Word or Excel · up to 10 MB',
    remove: 'Delete file',
  },
  detail: {
    label: 'Parcel details',
    close: 'Close',
    trackingNo: 'Tracking No',
    copy: 'Copy the tracking number',
    query: 'Track',
    phone: 'Phone',
    carrier: 'Carrier',
    shipped: 'Shipped',
    expected: 'Expected Delivery',
    delivered: 'Delivered',
    cost: 'Shipping Cost',
    owner: 'Logged by',
    note: 'Note',
    info: 'Details',
    items: 'Stock Items',
    applied: 'Booked to stock',
    notApplied: 'Not booked to stock yet',
    files: 'Files',
    history: 'History',
    quickStatus: 'Update the status',
    quickStatusHint: 'Pick the new status as the parcel moves; dates and stock update on their own.',
    delete: 'Delete',
    edit: 'Edit',
  },
  access: {
    title: 'Parcel Permissions',
    subtitle: 'Who can send and receive parcels',
    help: 'Employees with the switch on can send and receive parcels from the My Parcels tab of their profile.',
    granted_one: '{{count}} person has access',
    granted_other: '{{count}} people have access',
    search: 'Search employees...',
    loading: 'Loading employees',
    empty: 'No matching employees.',
    admin: 'Administrator',
    adminHint: 'Administrators always have access',
    toggle: 'Parcel access for {{name}}',
    saved: 'Every change is saved right away.',
  },
};

export default cargo;
